<template>
  <div class="host-common">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>条码规则</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">条码规则</div>
      </div>
    </div>
    <div class="header-switch">
      <div class="header-switch-text">条码规则设置</div> 
    </div>

    <div class="common-barcode-content">
      <div style="width:50%;">
        <div style="display:flex;padding:50px 20px 0 60px;">
          <div style="width:80px;">
            <span style="width:80px;line-height:36px;display:block;">条码规则：</span>
            <span style="width:80px;line-height:72px;display:block;">条码规则：</span>
          </div>
          <Form ref="formValidate" :model="formInline" :rules="ruleInline" inline>
            <FormItem style="width:100%;">
              <RadioGroup v-model="numLength">
                <Radio label="6">6位</Radio>
                <Radio label="8">8位</Radio>
                <Radio label="10">10位</Radio>
                <Radio label="12">12位</Radio>
                <Radio label="13">13位</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem prop="num1">
              <Select v-model="formInline.num1" style="width: 80px">
                <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.lable }}</Option>
              </Select>
            </FormItem>
            <span class="line">-</span>
            <FormItem prop="num2">
              <Select v-model="formInline.num2" style="width: 80px">
                <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.lable }}</Option>
              </Select>
            </FormItem>
            <span class="line">-</span>
            <FormItem prop="num3">
              <Select v-model="formInline.num3" style="width: 80px">
                <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.lable }}</Option>
              </Select>
            </FormItem>
            <span class="line">-</span>
            <FormItem prop="num4">
              <Select v-model="formInline.num4" style="width: 80px">
                <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.lable }}</Option>
              </Select>
            </FormItem>
            <span class="line">-</span>
            <FormItem prop="num5">
              <Select v-model="formInline.num5" style="width: 80px">
                <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.lable }}</Option>
              </Select>
            </FormItem>
            <span class="line">-</span>
            <FormItem prop="num6">
              <Select v-model="formInline.num6" style="width: 80px">
                <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.lable }}</Option>
              </Select>
            </FormItem>
            <span class="line" v-if="numLength == '8' || numLength == '10' || numLength == '12' || numLength == '13'">-</span>
            <FormItem prop="num7" v-if="numLength == '8' || numLength == '10' || numLength == '12' || numLength == '13'">
              <Select v-model="formInline.num7" style="width: 80px">
                <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.lable }}</Option>
              </Select>
            </FormItem>
            <span class="line" v-if="numLength == '8' || numLength == '10' || numLength == '12' || numLength == '13'">-</span>
            <FormItem prop="num8" v-if="numLength == '8' || numLength == '10' || numLength == '12' || numLength == '13'">
              <Select v-model="formInline.num8" style="width: 80px">
                <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.lable }}</Option>
              </Select>
            </FormItem>
            <span class="line" v-if="numLength == '10' || numLength == '12' || numLength == '13'">-</span>
            <FormItem prop="lastNumber10" v-if="numLength == '10'">
              <Input style="width:200px;" v-model="formInline.lastNumber10" placeholder="00" />
            </FormItem>
            <FormItem prop="lastNumber12" v-if="numLength == '12'">
              <Input style="width:200px;" v-model="formInline.lastNumber12" placeholder="0000" />
            </FormItem>
            <FormItem prop="lastNumber13" v-if="numLength == '13'">
              <Input style="width:200px;" v-model="formInline.lastNumber13" placeholder="00000" />
            </FormItem>
          </Form>
        </div>
        <div style="width:100%;padding:0 0 30px 140px;">
          <Button style="width:68px;height:32px;margin-right:10px;" type="primary" :loading="loading" @click="handleSubmit('formValidate')">保存</Button>
          <Button style="width:68px;height:32px;" @click="init();">取消</Button>
        </div>
      </div>
      <div style="width:50%;border-left:1px solid #e8e8e8;padding:30px 40px 30px 35px;">
        <p style="color:#333;font-size:18px;">预览</p>
        <div class="review" v-if="numLength == '6'">
          {{formInline.num1 + formInline.num2 + formInline.num3 + formInline.num4 + formInline.num5 + formInline.num6}}
        </div>
        <div class="review" v-if="numLength == '8'">
          {{formInline.num1 + formInline.num2 + formInline.num3 + formInline.num4 + formInline.num5+ formInline.num6 + formInline.num7 + formInline.num8}}
        </div>
        <div class="review" v-if="numLength == '10'">
          {{formInline.num1 + formInline.num2 + formInline.num3 + formInline.num4 + formInline.num5 + formInline.num6 + formInline.num7 + formInline.num8 + formInline.lastNumber10}}
        </div>
        <div class="review" v-if="numLength == '12'">
          {{formInline.num1 + formInline.num2 + formInline.num3 + formInline.num4 + formInline.num5 + formInline.num6 + formInline.num7 + formInline.num8 + formInline.lastNumber12}}
        </div>
        <div class="review" v-if="numLength == '13'">
          {{formInline.num1 + formInline.num2 + formInline.num3 + formInline.num4 + formInline.num5 + formInline.num6 + formInline.num7 + formInline.num8 + formInline.lastNumber13}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "host-common-function",
  data() {
    const that = this;
    const numberReg1 = (rule, value, callback) => {
      const lengthReg1 = /^\d{2}$/.test(that.formInline.lastNumber10);
      if (lengthReg1) {
        callback();
      } else {
        callback(new Error("请输入2位数字"));
      }
    };
    const numberReg2 = (rule, value, callback) => {
      const lengthReg2 = /^\d{4}$/.test(that.formInline.lastNumber12);
      if (lengthReg2) {
        callback();
      } else {
        callback(new Error("请输入4位数字"));
      }
    };
    const numberReg3 = (rule, value, callback) => {
      const lengthReg3 = /^\d{5}$/.test(that.formInline.lastNumber13);
      if (lengthReg3) {
        callback();
      } else {
        callback(new Error("请输入5位数字"));
      }
    };
    return {
      list: [
        {lable:  '0', value:  '0'},
        {lable:  '1', value:  '1'},
        {lable:  '2', value:  '2'},
        {lable:  '3', value:  '3'},
        {lable:  '4', value:  '4'},
        {lable:  '5', value:  '5'},
        {lable:  '6', value:  '6'},
        {lable:  '7', value:  '7'},
        {lable:  '8', value:  '8'},
        {lable:  '9', value:  '9'},
        {lable:  'A', value:  'A'},
        {lable:  'B', value:  'B'},
        {lable:  'C', value:  'C'},
        {lable:  'D', value:  'D'},
        {lable:  'E', value:  'E'},
        {lable:  'F', value:  'F'},
        {lable:  'G', value:  'G'},
        {lable:  'H', value:  'H'},
        {lable:  'I', value:  'I'},
        {lable:  'J', value:  'J'},
        {lable:  'K', value:  'K'},
        {lable:  'L', value:  'L'},
        {lable:  'M', value:  'M'},
        {lable:  'N', value:  'N'},
        {lable:  'O', value:  'O'},
        {lable:  'P', value: 'P'},
        {lable: 'Q', value: 'Q'},
        {lable: 'R', value: 'R'},
        {lable: 'S', value: 'S'},
        {lable: 'T', value: 'T'},
        {lable: 'U', value: 'U'},
        {lable: 'V', value: 'V'},
        {lable: 'W', value: 'W'},
        {lable: 'X', value: 'X'},
        {lable: 'Y', value: 'Y'},
        {lable: 'Z', value: 'Z'},
      ],
      numLength: '6',
      formInline: {
        num1: "",
        num2: "",
        num3: "",
        num4: "",
        num5: "",
        num6: "",
        num7: "",
        num8: "",
        lastNumber10: '',
        lastNumber12: '',
        lastNumber13: '',
      },
      ruleInline: {
        num1: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        num2: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        num3: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        num4: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        num5: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        num6: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        num7: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        num8: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        lastNumber10: [{ required: true, validator: numberReg1, trigger: "blur" }],
        lastNumber12: [{ required: true, validator: numberReg2, trigger: "blur" }],
        lastNumber13: [{ required: true, validator: numberReg3, trigger: "blur" }],
      },
      loading: false,
    }
  },
  watch: {
    numLength(val, oldVal) {
      if (val) {
        // this.formInline.num1 = "";
        // this.formInline.num2 = "";
        // this.formInline.num3 = "";
        // this.formInline.num4 = "";
        // this.formInline.num5 = "";
        // this.formInline.num6 = "";
        // this.formInline.num7 = "";
        // this.formInline.num8 = "";
        // this.formInline.lastNumber10 = "";
        // this.formInline.lastNumber12 = "";
        // this.formInline.lastNumber13 = "";
        this.$refs['formValidate'].resetFields();
      }
    }
  },
  methods: {
    init() {

    },
    async handleSubmit(name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {};
      if (this.numLength == '6') {
        req = {

        }
      }
      console.log(req);
    },
    // 验证表单
    validForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.host-common {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 35px 18px 35px;
    background: #fff;
    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }
    &-box {
      flex: 1;
      text-align: right;
    }
  }
  .common-barcode-content {
    min-width: 1000px;
    margin: 30px;
    // padding: 80px 0 100px 0;
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    .line {
      line-height: 30px;
      margin-right: 10px;
    }
    .review {
      margin-top: 37px;
      border: solid 1px #e6e6e6;
	    background-color: #fafafa;
      height: 130px;
      line-height: 130px;
      text-align: center;
      color: #262626;
      font-size: 24px;
    }
  }
}
</style>